import { useEffect, useState } from "react";
import ActionHeader from "../../../UI/action-header/action-header";
import "./location.scss";
import { ClickAwayListener, Grid } from '@mui/material';
import { Box } from '@mui/system';
import add from "../../../assets/common-imgs/add.png";
import people from "../../../assets/setting/location/people.png";
import colon from "../../../assets/setting/location/colon.png";
import { locationCardData } from '../../../mock-data/location-mock-data';
import GlobalCard from '../../../UI/card/GlobalCard';
import AddLocation from './add-location/addLocation';
import { getLocations } from "./features/functions";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import LocationDeleteModal from "./location-delete-modal";

const Location = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState('0');
  const [editModalShow, setEditModalShow] = useState(false);

  const [addLocation, setAddLocation] = useState(false);
  const dispatch = useAppDispatch();
  const { locations } = useAppSelector((state:any) => state?.settings);
  console.log(locations);

  useEffect(() => {
    dispatch(getLocations());
  }, []);

  return (
    <div>
      {!addLocation && <>
        <Box>
          <ActionHeader heading='Location' isbuttonRequired={true} buttonName='add location' buttonImg={add} handleClick={setAddLocation} />
        </Box>
        <GlobalCard>

          <Grid container justifyContent="space-between" flexWrap="wrap" className='location'>
            {locationCardData.map((data: any) => {
              return (
                <>
                  <Grid item className='card' lg={2.8} md={6} sm={12} xs={12} display='flex' justifyContent="space-between" >
                    <Box display='flex' justifyContent="space-between">
                      <img src={data.img} alt='loaction1' />
                      <Box className='detail' display='flex' flexDirection='column' justifyContent='space-between'>
                        <h4 className='h4 fw-600'>{data.country}</h4>
                        <h5 className='h5 fw-600'>{data.city}</h5>
                        <Box display='flex'>
                          <img src={people} alt='people' />
                          <p className='fs-14 lh-22'>{data.employee}employee</p>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ pr: 1 }}>
                      <Box sx={{ position: "relative", right: 0, }} className="br-5" ><img src={colon} className='cursor-pointer' onClick={() => setSelectedId(data.id)} />
                        {/* <Box > */}
                        {selectedId === data.id &&
                          <ClickAwayListener onClickAway={() => setSelectedId("0")}>
                            <Box sx={{ position: "absolute", right: "1px", top: "30px", borderRadius: "5px", background: "#FFFFFF", boxShadow: "0px 0px 0px 4px rgba(247, 136, 18, 0.05);", py: 1, px: 3, display: 'flex', flexDirection: "column", justifyContent: "space-between" }}>
                              <p className='cursor-pointer margin-bottom' onClick={() => { setEditModalShow(true); setSelectedId('0') }}>Edit</p>
                              <p className='cursor-pointer' onClick={() => { setShowDeleteModal(true); setSelectedId('0') }} >Delete</p>
                            </Box>
                          </ClickAwayListener>
                        }
                      </Box>
                    </Box>
                  </Grid>
                </>
              )
            })}
          </Grid>
        </GlobalCard>
        <LocationDeleteModal showDeleteModal={showDeleteModal} setShowDeleteModal={setShowDeleteModal}/>
        
      </>}
      {addLocation && <AddLocation />}
    </div>
  );
};

export default Location;
